import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import {
  formatRowProductTitle,
  rowIsOpenForPicking,
  rowIsFullyCollected,
} from '../../helpers/pickingProductMatch';
import { terminalColors } from '../../theme/terminalStyles';

const dialogPaperSx = {
  bgcolor: terminalColors.gradientTop,
  backgroundImage: 'none',
  borderRadius: 2,
  m: { xs: 1, sm: 2 },
};

const ProductPickDialog = ({ open, rows, onClose, onSelect }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: dialogPaperSx }}>
    <DialogTitle sx={{ fontWeight: 600, color: terminalColors.textPrimary }}>
      Оберіть товар
    </DialogTitle>
    <DialogContent sx={{ pt: 0 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Знайдено кілька позицій. Позиції з документа — зверху; оберіть потрібну:
      </Typography>
      <List dense disablePadding>
        {rows.map((row) => {
          const { name, article } = formatRowProductTitle(row);
          const doc = row.saleProduct ? Number(row.saleProduct.quantity) : 0;
          const fact = Number(row.pickLine?.quantity ?? 0);
          const open = rowIsOpenForPicking(row);
          const collected = rowIsFullyCollected(row);
          const key = row.saleProduct?.id ?? row.pickLine?.id;
          return (
            <ListItemButton
              key={key}
              onClick={() => onSelect(row)}
              sx={{
                borderRadius: 1.5,
                mb: 0.75,
                border: '2px solid',
                borderColor: open ? terminalColors.accentOrange : 'rgba(183, 177, 197, 0.85)',
                bgcolor: open ? terminalColors.cardWhite : 'rgba(255, 255, 255, 0.78)',
                boxShadow: open
                  ? '0 2px 8px rgba(255, 179, 71, 0.25)'
                  : '0 1px 4px rgba(0,0,0,0.05)',
                '&:hover': {
                  bgcolor: open ? terminalColors.cardWhite : 'rgba(255, 255, 255, 0.92)',
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.secondary">
                    Артикул: <strong>{article}</strong>
                    {collected ? (
                      <Typography
                        component="span"
                        variant="caption"
                        sx={{ ml: 1, color: 'text.disabled' }}
                      >
                        · зібрано
                      </Typography>
                    ) : null}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant="body1" fontWeight={600} component="span" display="block">
                      {name}
                    </Typography>
                    <Typography variant="body2" component="span" color="text.secondary">
                      Док: {doc} · Факт: {fact}
                    </Typography>
                  </>
                }
              />
            </ListItemButton>
          );
        })}
      </List>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <TerminalOrangeButton
        fullWidth
        onClick={onClose}
        sx={{
          bgcolor: 'transparent',
          color: 'text.primary',
          boxShadow: 'none',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.04)', boxShadow: 'none' },
        }}
      >
        Скасувати
      </TerminalOrangeButton>
    </DialogActions>
  </Dialog>
);

export default ProductPickDialog;
